module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__bd",
    staticStyle: {
      "background-color": "#f1f1f1"
    }
  }, _vm._l((_vm.listInfo), function(sealOut, index) {
    return _c('div', {
      class: [{
        'gap': index != 0
      }, 'weui-form-preview'],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.detail(sealOut.id, sealOut.orderId, sealOut.taskId, sealOut.taskName)
        }
      }
    }, [_c('div', {
      staticClass: "weui-form-preview__hd"
    }, [_c('div', {
      staticClass: "weui-form-preview__item"
    }, [_c('label', {
      staticClass: "weui-form-preview__label"
    }, [_vm._v("标题")]), _vm._v(" "), _c('em', {
      staticClass: "weui-form-preview__value"
    }, [_vm._v(_vm._s(sealOut.title))])])]), _vm._v(" "), _c('div', {
      staticClass: "weui-form-preview__bd"
    }, [_c('div', {
      staticClass: "weui-form-preview__item"
    }, [_c('label', {
      staticClass: "weui-form-preview__label"
    }, [_vm._v("创建时间")]), _vm._v(" "), _c('span', {
      staticClass: "weui-form-preview__value"
    }, [_vm._v(_vm._s(sealOut.createTime))])]), _vm._v(" "), _c('div', {
      staticClass: "weui-form-preview__item"
    }, [_c('label', {
      staticClass: "weui-form-preview__label"
    }, [_vm._v("状态")]), _vm._v(" "), _c('span', {
      staticClass: "weui-form-preview__value"
    }, [_vm._v(_vm._s(_vm.getSealOutState(sealOut)))])])]), _vm._v(" "), _c('div', {
      staticClass: "weui-form-preview__ft"
    }, [_c('a', {
      staticClass: "weui-form-preview__btn weui-form-preview__btn_primary",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.detail(sealOut.id, sealOut.orderId, sealOut.taskId, sealOut.taskName)
        }
      }
    }, [_vm._v("查看")])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b20b4ecc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listSealOut.vue
// module id = 146
// module chunks = 2